import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsPageViews } from '../../../../shared/enums/analytics.enum';
import { EventInteraction, GTMInteractions, SECTIONS } from '../../../../shared/models/Constants';
import { HtmlSeguroPipe } from '../../../../shared/pipes/html-seguro.pipe';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { IPushEjecucion } from '../../models/push-ejecucion';

@Component({
  selector: 'app-push-ejecucion',
  templateUrl: './push-ejecucion.page.html',
  styleUrls: ['./push-ejecucion.page.scss'],
})
export class PushEjecucionPage implements OnInit {

  @Input() Params: IPushEjecucion = {}

  constructor(
    private modalC: ModalController
    , private htmlSeguro: HtmlSeguroPipe
    , private analytics: AnalyticsService
    , private sharedAnalyticsS: SharedAnalyticsService
  ) { }

  ngOnInit() {
    this.sharedAnalyticsS.trackPageView(EAnalyticsPageViews.executionNotifView, SECTIONS.AUTOEVALUACION);
  }

  public async onConfirm(confirm: boolean) {
    this.modalC.dismiss(confirm)

    const eventAnalytics = confirm ? GTMInteractions.notificationPhotoAcceptEvent : GTMInteractions.notificationPhotoDenyEvent
    eventAnalytics.fbEvent.data_accion = await this.analytics.getScreenName()
    eventAnalytics.gtmEvent.accion = `/${await this.analytics.getScreenName()}`
    this.analytics.sendEventAnalytics(eventAnalytics, EventInteraction)
  }

  public sanitizer = (html: string) => this.htmlSeguro.transform(html)

}
